import {
  config
} from '../_config';
import {
  authHeader,
  handleResponse
} from '../_helpers';

export const filesService = {
  uploadDogDoc,
  getTypesDocList,
  getDogDocuments,
  getOneDocument,
  stUploadDogTiltleDoc

}

function uploadDogDoc(file, dogId, docType) {

  let fd = new FormData();
  fd.append('file', file, file.name);
  fd.append('dogId', dogId);
  fd.append('docType', docType);


  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader()
    },
    body: fd
  };

  return fetch(`${config.apiUrl}/uploadDogDoc`, requestOptions)
    .then(handleResponse);

}

function getTypesDocList() {

  const requestOptions = {
    method: 'GET',
    headers: {
      ...authHeader()
    }
  };

  return fetch(`${config.apiUrl}/doctype`, requestOptions)
    .then(handleResponse);

}

function getDogDocuments(dogId) {

  const requestOptions = {
    method: 'GET',
    headers: {
      ...authHeader()
    }
  };

  return fetch(`${config.apiUrl}/dogDocuments/${dogId}`, requestOptions)
    .then(handleResponse);

}

function getOneDocument(docId) {  
  const requestOptions = {
    method: 'GET',
    headers: {
     ...authHeader()
    }
  };

  return fetch(`${config.apiUrl}/downloadDoc/${docId}`, requestOptions)  
  .then(function (response) {
    console.log(response); 
    if (response.ok) {
      return response.blob();
    } else {
      return null;
    }
  })
  .catch(function (error) {
    console.log(error);
  })


}

function stUploadDogTiltleDoc(file, dogId, docType) {
  let fd = new FormData();
  fd.append('file', file, file.name);
  fd.append('dogId', dogId);
  fd.append('docType', docType);


  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader()
    },
    body: fd
  };

  return fetch(`${config.apiUrl}/uploadDogDoc`, requestOptions)
    .then(handleResponse);
}